import React from "react";

const Skills = () => {
  const skills = [
    { name: "Laravel", img: "assets/imgs/skill/01.png" },
    { name: "Core PHP", img: "assets/imgs/skill/02.png" },
    { name: "MySQL", img: "assets/imgs/skill/03.png" },
    { name: "ReactJS", img: "assets/imgs/skill/04.png", style: { padding: "5px" } },
    { name: "Adobe Photoshop", img: "assets/imgs/skill/05.png", customClass: "custom-border-radius" },
    { name: "HTML5", img: "assets/imgs/skill/06.png" },
    { name: "CSS", img: "assets/imgs/skill/07.png" },
    { name: "JavaScript", img: "assets/imgs/skill/08.png" },
  ];

  return (
    <section className="bd-counter__area section-space theme-bg-secondary">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-12 text-center">
            <div className="section__title-wrapper section__title-space">
              <span className="section__subtitle">Professional Skills</span>
            </div>
          </div>
        </div>
        <div className="row g-5">
          {skills.map((skill, index) => (
            <div key={index} className="col-lg-3 col-md-4 col-sm-6 col-6">
              <div
                className="skill__wrapper skill__item wow fadeIn"
                data-wow-delay={`.${3 + index * 2}s`}
              >
               <div
  className={`skill__icon-thumb ${skill.name === "MySQL" ? "white-bg" : ""} ${skill.name === "ReactJS" ? "black-bg" : ""}`}
  style={skill.style || {}}
>

                  <img src={skill.img} alt="img not found" />
                </div>
                <div className="skill__content">
                  <span className="skill__name">{skill.name}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;
